import React, { useEffect, useState } from "react";
import { useLoaderData } from "react-router-dom";
import GreenSpinner from "../../../../Shared/Loading/GreenSpinner";
import toast from "react-hot-toast";
import ModalShortlistedGreen from "./ModalShortlistedGreen";

const AllShortlistedGreen = ({ postData }) => {
  const [AppliedData, setAppliedData] = useState([]);
  const [page, setPage] = useState(1);
  const [teacherEmail, setTeacherEmail] = useState(""); // State to store teacherEmail filter
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true);
  const [isModalVisible, setIsModalVisible] = useState(false);

  const openModal = () => {
    setIsModalVisible(true);
  };

  const closeModal = () => {
    setIsModalVisible(false);
  };
  const fetchAppliedData = async () => {
    try {
      const response = await fetch(
        `https://tutor-tree-server-1.vercel.app/allTutorsReqGreen/${postData.jobId}?page=${page}&limit=10&teacherEmail=${teacherEmail}`
      );
      const data = await response.json();
      setAppliedData(data.result);
      setTotalPages(data.pages);
      setLoading(false);
    } catch (error) {
      console.error("Error fetching AppliedData:", error);
    }
  };

  useEffect(() => {
    fetchAppliedData();
  }, [page, teacherEmail]); // Re-fetch data when page or teacherEmail changes

  if (loading) {
    return <GreenSpinner></GreenSpinner>;
  }

  const handleDoubleArchive = (applyId, jobId) => {
    const archiveApply = fetch(
      `https://tutor-tree-server-1.vercel.app/green/archive/${applyId}`,
      {
        method: "PUT",
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.modifiedCount > 0) {
          toast.success("Application archive successful.");
        }
      })
      .catch((error) => {
        console.error("Error archiving application:", error);
      });

    const archiveJob = fetch(
      `https://tutor-tree-server-1.vercel.app/green/archive-job/${jobId}`,
      {
        method: "PUT",
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.modifiedCount > 0) {
          toast.success("Job archive successful.");
        }
      })
      .catch((error) => {
        console.error("Error archiving job:", error);
      });

    Promise.all([archiveApply, archiveJob])
      .then(() => {
        // Re-fetch the updated data after both archive operations are done
        fetchAppliedData();
      })
      .catch((error) => {
        console.error("Error in double archive operation:", error);
      });
  };
  const handleDoubleShortlisted = (applyId, jobId) => {
    const archiveApply = fetch(
      `https://tutor-tree-server-1.vercel.app/green/classBooked/${applyId}`,
      {
        method: "PUT",
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.modifiedCount > 0) {
          toast.success("Application class booked successful.");
        }
      })
      .catch((error) => {
        console.error("Error archiving application:", error);
      });

    const archiveJob = fetch(
      `https://tutor-tree-server-1.vercel.app/green/classBooked-job/${jobId}`,
      {
        method: "PUT",
      }
    )
      .then((res) => res.json())
      .then((data) => {
        if (data.modifiedCount > 0) {
          toast.success("Job class booked successful.");
        }
      })
      .catch((error) => {
        console.error("Error class booked job:", error);
      });

    Promise.all([archiveApply, archiveJob])
      .then(() => {
        // Re-fetch the updated data after both archive operations are done
        fetchAppliedData();
      })
      .catch((error) => {
        console.error("Error in double archive operation:", error);
      });
  };

  return (
    <div className="bg-white h-screen">
    {/* Teacher Email Filter */}
    <h1 className="m-5 font-lg font-montserrat">Job Id: {postData.jobId}</h1>
    <input
      type="text"
      value={teacherEmail}
      onChange={(e) => setTeacherEmail(e.target.value)}
      placeholder="Filter by Teacher Email"
      className="mx-4 border border-green-500 rounded-lg focus:border-green-500 text-lg font-montserrat"
    />

    {/* Display Data */}
    <div className="grid grid-cols-4 gap-5 p-5">
      {AppliedData.map((apply) => (
        <div
          className="w-full  bg-green-100 border border-green-500 rounded"
          key={apply._id}
        >
          <div className="w-full h-10 bg-green-500 px-2 flex items-center justify-between">
            <h1 className="text-white font-montserrat">
              {apply.applyingDate}
            </h1>
            <div className="flex justify-between items-center">
              {apply.GreenClassBooked === "done" ? (
                <img
                  alt=""
                  className="w-8 h-8"
                  src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTExLjM3NSA1MTEuMzc1IiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCA1MTIgNTEyIiB4bWw6c3BhY2U9InByZXNlcnZlIiBjbGFzcz0iIj48Zz48cGF0aCBmaWxsPSIjMGVkNjc4IiBkPSJtNTExLjM3NSAyNTUuNjg4LTU3Ljg5LTY0LjI3MyA5LjA2NC04Ni4wNDYtODQuNjUxLTE3LjkyLTQzLjE4LTc1LjAxMi03OS4wMyAzNS4zMjEtMTAuNjY3IDIwNy45MyAxMC42NjcgMjA3LjkyOSA3OS4wMzEgMzUuMzIxIDQzLjE3OS03NS4wMTEgODQuNjUxLTE3LjkyMS05LjA2NC04Ni4wNDZ6IiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMGVkNjc4Ij48L3BhdGg+PHBhdGggZmlsbD0iIzA0ZWI4NCIgZD0ibTE3Ni42NTYgMTIuNDM3LTQzLjE3OSA3NS4wMTItODQuNjUxIDE3LjkyMSA5LjA2NCA4Ni4wNDVMMCAyNTUuNjg4bDU3Ljg5IDY0LjI3Mi05LjA2NCA4Ni4wNDYgODQuNjUxIDE3LjkyMSA0My4xOCA3NS4wMTEgNzkuMDMxLTM1LjMyMVY0Ny43NTh6IiBvcGFjaXR5PSIxIiBkYXRhLW9yaWdpbmFsPSIjMDRlYjg0Ij48L3BhdGg+PHBhdGggZmlsbD0iI2Y3ZjBlYiIgZD0ibTM2Mi44NzggMTk5LjcwMi0yMi4zODEtMTkuOTc3LTg0LjgwOSA5NS4wMTYtMTAuNjY3IDIzLjYxMyAxMC42NjcgMjEuNDM5eiIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iI2Y3ZjBlYiI+PC9wYXRoPjxwYXRoIGZpbGw9IiNmZmZiZjUiIGQ9Im0xNjYuNTYgMjMzLjA5NS0yMS4yMTIgMjEuMjEzIDg5LjE4NSA4OS4xODYgMjEuMTU1LTIzLjcwMXYtNDUuMDUybC0yMi4zOTMgMjUuMDg4eiIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iI2ZmZmJmNSI+PC9wYXRoPjwvZz48L3N2Zz4="
                />
              ) : (
                <button
                  className="text-sm shadow-lg text-white font-roboto bg-green-900 rounded px-2 py-1"
                  onClick={() =>
                    handleDoubleShortlisted(apply._id, postData._id)
                  }
                >
                  Class Booked
                </button>
              )}
              <button
                className="text-sm shadow-lg ml-2 text-green-900 font-roboto bg-green-100 rounded px-2 py-1"
                onClick={() => handleDoubleArchive(apply._id, postData._id)}
              >
                Archive
              </button>
            </div>
            {/* <button onClick={() => handleMakeArchiveJob(postData._id)}>Double Archive</button> */}
          </div>
          <button onClick={openModal}>
            <div className="px-2 py-2 flex justify-start items-start flex-col">
              <h1 className="text-lg font-montserrat">
                Name : {apply.teacherName}
              </h1>
              <h1 className="text-sm font-montserrat">
                Email : {apply.teacherEmail}
              </h1>
              <h1 className="text-sm font-montserrat">
                Phone : {apply.phone}
              </h1>
              <h1 className="text-sm font-montserrat">
                HSC Result : {apply.teacherHSCresult}
              </h1>
              <h1 className="text-sm font-montserrat">
                HSC Group : {apply.teacherHSCgroup}
              </h1>
              <h1 className="text-sm font-montserrat">
                Hons Institute : {apply.teacherHonsInstitute}
              </h1>
              <h1 className="text-sm font-montserrat">
                Hons Major : {apply.teacherHonsMajor}
              </h1>
              <h1 className="text-sm font-montserrat">
                Hons Semester : {apply.teacherHonsSemester}
              </h1>
            </div>
          </button>
          <div>
            <ModalShortlistedGreen
              apply={apply}
              isVisible={isModalVisible}
              onClose={closeModal}
            />
          </div>
        </div>
      ))}
    </div>

    {/* Pagination Controls */}

    <div className="flex justify-center items-start ">
      <div className="flex justify-between my-5 w-[300px]">
        <button
          onClick={() => setPage(page > 1 ? page - 1 : 1)}
          disabled={page === 1}
        >
          <img
            className="w-10"
            alt=""
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGcgdHJhbnNmb3JtPSJtYXRyaXgoLTEsLTEuMjI0NjQ2Nzk5MTQ3MzUzMmUtMTYsMS4yMjQ2NDY3OTkxNDczNTMyZS0xNiwtMSw1MTIsNTEyKSI+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
          />
        </button>
        <span className="text-lg font-roboto">
          Page {page} of {totalPages}
        </span>
        <button
          onClick={() => setPage(page < totalPages ? page + 1 : totalPages)}
          disabled={page === totalPages}
        >
          <img
            className="w-10"
            alt=""
            src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZlcnNpb249IjEuMSIgeG1sbnM6eGxpbms9Imh0dHA6Ly93d3cudzMub3JnLzE5OTkveGxpbmsiIHdpZHRoPSI1MTIiIGhlaWdodD0iNTEyIiB4PSIwIiB5PSIwIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiIgc3R5bGU9ImVuYWJsZS1iYWNrZ3JvdW5kOm5ldyAwIDAgNTEyIDUxMiIgeG1sOnNwYWNlPSJwcmVzZXJ2ZSIgY2xhc3M9IiI+PGc+PHBhdGggZD0iTTI1NiAwQzExNC44MzcgMCAwIDExNC44MzcgMCAyNTZzMTE0LjgzNyAyNTYgMjU2IDI1NiAyNTYtMTE0LjgzNyAyNTYtMjU2UzM5Ny4xNjMgMCAyNTYgMHptNzkuMDgzIDI3MS4wODNMMjI4LjQxNiAzNzcuNzQ5QTIxLjI3NSAyMS4yNzUgMCAwIDEgMjEzLjMzMyAzODRhMjEuMjc3IDIxLjI3NyAwIDAgMS0xNS4wODMtNi4yNTFjLTguMzQxLTguMzQxLTguMzQxLTIxLjgyNCAwLTMwLjE2NUwyODkuODM1IDI1NmwtOTEuNTg0LTkxLjU4NGMtOC4zNDEtOC4zNDEtOC4zNDEtMjEuODI0IDAtMzAuMTY1czIxLjgyNC04LjM0MSAzMC4xNjUgMGwxMDYuNjY3IDEwNi42NjdjOC4zNDEgOC4zNDEgOC4zNDEgMjEuODIzIDAgMzAuMTY1eiIgZmlsbD0iIzAwODAwMCIgb3BhY2l0eT0iMSIgZGF0YS1vcmlnaW5hbD0iIzAwMDAwMCIgY2xhc3M9IiI+PC9wYXRoPjwvZz48L3N2Zz4="
          />
        </button>
      </div>
    </div>
  </div>
  );
};

export default AllShortlistedGreen;
